import { Button, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { getSupplierTypes } from "../../../../api/supplierType";
import { alertError } from "../../../../utils/logger";
import EntityInfoDialog from "../../../components/dialogs/EntityInfoDialog";
import Table, { buttonsStyle } from "../../../components/tables/table";
import SupplierTypeContent from "./SupplierTypeContent";

function getData(supplierTypes) {
	let data = [];
	for (let i = 0; i < supplierTypes.length; ++i) {
		const elem = {};
		const supplierType = supplierTypes[i];

		elem.descripcion = supplierType?.descripcion;
		elem.id = supplierType?.id;

		data = data.concat(elem);
	}
	return data;
}

export default function SupplierTypesPage() {
	const [data, setData] = useState([]);
	const [selectedSupplierType, setSelectedSupplierType] = useState(null);

	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [
		openSupplierTypeInfoDialog,
		setOpenSupplierTypeInfoDialog,
	] = useState(null);

	const [refresh, setRefresh] = useState(false);

	const history = useHistory();

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		return (
			<>
				<Tooltip title="Editar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={(e) => {
							e.stopPropagation();
							history.push(
								"/tipos-proveedores/" + cell + "/edit"
							);
						}}
					>
						<EditIcon />
					</Button>
				</Tooltip>
			</>
		);
	}

	const columns = [
		{ dataField: "descripcion", text: "Descripción", sort: true },
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	useEffect(() => {
		getSupplierTypes(loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setData(res.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage:
						"No se han podido obtener los tipos de proveedores.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="Tipos de proveedores">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() =>
								history.push("/tipos-proveedores/edit")
							}
						>
							Nuevo tipo
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table
						data={getData(data)}
						columns={columns}
						rowEvents={{
							onClick: (e, row, rowIndex) => {
								const supplierType = data?.find(
									(x) => x.id === row.id
								);
								setSelectedSupplierType(supplierType);
								setOpenSupplierTypeInfoDialog(true);
							},
						}}
					/>
					<EntityInfoDialog
						title={
							"Tipo de proveedor: " +
							selectedSupplierType?.descripcion
						}
						open={openSupplierTypeInfoDialog}
						setOpen={setOpenSupplierTypeInfoDialog}
						content={
							<SupplierTypeContent
								supplierType={selectedSupplierType}
							/>
						}
					/>
				</CardBody>
			</Card>
		</>
	);
}
